<template>
  <div
    class="absolute top-0 left-0 w-full h-full bg-black z-20 bg-opacity-20 flex"
    @click.self="emit('close')"
  >
    <div
      class="mx-auto mt-36 mb-auto bg-white rounded border-2 border-primary"
    >
      <div class="flex items-center bg-white relative shadow-md">
        <AppIcon
          icon="far fa-robot"
          fixed-width
          :bounce="isBusy"
          class="absolute left-2 h-4"
        />
        <input
          ref="searchInput"
          v-model="searchValue"
          v-maintain-focus
          :disabled="isBusy"
          class="p-3 pl-10 w-[640px] focus:outline-none"
          :class="{'text-gray-700': isBusy}"
          placeholder="Wat wil je doen?"
          @keydown.down="inputEvents.onPressArrowDown"
          @keydown.up="inputEvents.onPressArrowUp"
          @keyup.escape="emit('close')"
          @keyup.enter.exact="inputEvents.onPressEnter"
          @keyup.ctrl.enter.exact="inputEvents.onPressTab"
        >
        <KeyboardKey
          class="cursor-pointer select-none absolute right-4 text-xs hover:text-primary"
          @click="emit('close')"
        >
          Esc
        </KeyboardKey>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import { findKey } from "lodash";
import { vMaintainFocus } from "~/directives/vMaintainFocus";
import { useWitService } from "~/useWitService";
import { useApiResources } from "~stores/ApiResources.ts";

const { findByName } = useApiResources();
const { push } = useRouter();
const { fetchRawAnswer } = useWitService();
const searchInput = ref<HTMLInputElement | null>();
const searchValue = ref('');
const isBusy = ref(false);

const emit = defineEmits(['close']);

const inputEvents = {
  onPressArrowDown: () => {
    // Wrap around if we reach the end
  },
  onPressArrowUp: () => {
    // Wrap around if we reach the start
  },
  onPressEnter: async () => {
    try {
      isBusy.value = true;
      const result = await fetchAnswer(searchValue.value);

      processResult(result);
    } catch (error) {
      console.error(error);
    } finally {
      searchValue.value = '';
      isBusy.value = false;
    }
  },
  onPressTab: () => {
  }
};

function fetchAnswer(input: string) {
  return fetchRawAnswer(input);
}

const resourceToSubjectsMap = {
  "sales-order": ["verkopen", "verkooporders"],
  "purchase-order": ["inkopen", "inkooporders"],
  "production-order": ["producties", "productieorders"]
};

function processResult(result: any) {
  const subject = result.entities["subject:subject"][0]["value"];
  const dateInfo = result.entities["wit$datetime:datetime"][0]["values"][0];

  let dateFilter = {
    filterType: "date",
    type: "greaterThanOrEqual",
    dateFrom: dayjs(dateInfo.value).format("YYYY-MM-DD"),
  };
  console.log(dateInfo);
  if (dateInfo.grain == "week") {
    dateFilter = {
      filterType: "date",
      type: "inRange",
      dateFrom: dayjs(dateInfo.value).format("YYYY-MM-DD"),
      dateTo: dayjs(dateInfo.value).add(7, 'days').format("YYYY-MM-DD"),
    }
  }

  if (dateInfo.grain == "month") {
    dateFilter = {
      filterType: "date",
      type: "inRange",
      dateFrom: dayjs(dateInfo.value).format("YYYY-MM-DD"),
      dateTo: dayjs(dateInfo.value).add(1, 'month').format("YYYY-MM-DD"),
    }
  }

  const resource = findByName(findKey(resourceToSubjectsMap, subjects => subjects.includes(subject)));
  push({
    path: `/${resource.name}/index`,
    query: {
      filters: JSON.stringify({
        deliveryDate: dateFilter
      })
    },
  });

  emit('close');
}

</script>

<style scoped>

</style>
